// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RoleCode } from "./RoleCode";
import {
  RoleCodeFromJSON,
  RoleCodeFromJSONTyped,
  RoleCodeToJSON,
  RoleCodeToJSONTyped,
} from "./RoleCode";

/**
 *
 * @export
 * @interface ResponsibleParty
 */
export interface ResponsibleParty {
  /**
   * Volledige naam van de voor metadata verantwoordelijke organisatie.
   */
  organisationName: string;
  /**
   * E-mail adres van de organisatie.
   */
  email: string;
  /**
   * Beschrijving op welke manier de organisatie betrokken is bij de metadata.
   */
  role?: RoleCode;
}

/**
 * Check if a given object implements the ResponsibleParty interface.
 */
export function instanceOfResponsibleParty(value: object): value is ResponsibleParty {
  if (
    (!("organisationName" in (value as Record<string, any>)) &&
      !("organisation_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["organisationName"] === undefined &&
      (value as Record<string, any>)["organisation_name"] === undefined)
  )
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  return true;
}

export function ResponsiblePartyFromJSON(json: any): ResponsibleParty {
  return ResponsiblePartyFromJSONTyped(json, false);
}

export function ResponsiblePartyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResponsibleParty {
  if (json == null) {
    return json;
  }
  return {
    organisationName: json["organisation_name"],
    email: json["email"],
    role: json["role"] == null ? undefined : RoleCodeFromJSON(json["role"]),
  };
}

export function ResponsiblePartyToJSON(json: any): ResponsibleParty {
  return ResponsiblePartyToJSONTyped(json, false);
}

export function ResponsiblePartyToJSONTyped(
  value?: ResponsibleParty | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    organisation_name: value["organisationName"],
    email: value["email"],
    role: RoleCodeToJSON(value["role"]),
  };
}
